

export const setUserMessageData = (data) => {
    return {
      type: 'SET_USER_MESSAGE_DATA',
      payload: data
    };
  };
  